import { createBrowserRouter, RouterProvider } from 'react-router'
import { Toasts } from './components/Toasts'
import { AuthGate } from './features/auth/AuthGate'
import { AppShell } from './features/shell/AppShell'
import { EmptyPane } from './features/shell/EmptyPane'
import { ConversationRoute } from './features/conversation/ConversationRoute'
import { SearchScreen } from './features/search/SearchScreen'
import { LazyScreen } from './features/shell/LazyScreen'
import { UpdatePrompt } from './features/shell/UpdatePrompt'

const router = createBrowserRouter([
  {
    element: <AuthGate />,
    children: [
      {
        path: '/',
        element: <AppShell />,
        children: [
          { index: true, element: <EmptyPane /> },
          { path: 'c/:channelId', element: <ConversationRoute /> },
          { path: 'search', element: <SearchScreen /> },
          { path: 'settings', element: <LazyScreen name="settings" /> },
          { path: 'admin', element: <LazyScreen name="adminHome" /> },
          { path: 'admin/people', element: <LazyScreen name="adminPeople" /> },
          { path: 'admin/people/:id', element: <LazyScreen name="adminPerson" /> },
          { path: 'admin/audit', element: <LazyScreen name="auditLog" /> },
          { path: 'admin/devices', element: <LazyScreen name="adminDevices" /> },
          { path: 'admin/channels', element: <LazyScreen name="adminChannels" /> },
          { path: 'admin/bots', element: <LazyScreen name="adminBots" /> },
          { path: 'admin/integrations', element: <LazyScreen name="adminIntegrations" /> },
          { path: 'admin/provisioning', element: <LazyScreen name="adminProvisioning" /> },
          { path: '*', element: <EmptyPane notFound /> },
        ],
      },
    ],
  },
])

export function App() {
  return (
    <>
      <RouterProvider router={router} />
      <UpdatePrompt />
      <Toasts />
    </>
  )
}
